function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z",
  "data-name": "Rectangle 1244",
  style: {
    fill: "rgba(255,255,255,.03)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m5067.335 1777.578 5 4.375 5-4.375",
  style: {
    fill: "none",
    stroke: "#000"
  },
  transform: "translate(-5066.335 -1773.579)"
}));
export default SvgIconArrow12;